import { render, staticRenderFns } from "./InsCreateEditForm.vue?vue&type=template&id=535c527a&scoped=true&"
import script from "./InsCreateEditForm.vue?vue&type=script&lang=js&"
export * from "./InsCreateEditForm.vue?vue&type=script&lang=js&"
import style0 from "./InsCreateEditForm.vue?vue&type=style&index=0&id=535c527a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c527a",
  null
  
)

export default component.exports